// extracted by mini-css-extract-plugin
export default {"restaurants-menus-icons-label":"mdlC4M","restaurantsMenusIconsLabel":"mdlC4M"};